<app-traitement-data titre="P90/95" [sousTitre]="patient!.p90_95?.date | aLaDateDu"
    [statut]="patient!.p90_95?.value ? 'info' : 'warning'">
    {{ (patient!.p90_95?.value | pression) ?? 'Pas de donnée' }}
</app-traitement-data>